export const UPLOAD_CARE_CDN_URL = 'https://ucarecdn.com';
